<template>
    <AppHeaderDropdown>
        <template slot="header">
            <span class="active">Target</span>
        </template>
        <template slot="dropdown">
            <b-dropdown-item v-if="hasKpi" to="/v2/target/indicators">
                {{ $t('indicators.indicators') }}
            </b-dropdown-item>
            <b-dropdown-item v-if="hasTarget" to="/v2/target/targets">
                {{ $t('targets.targets') }}
            </b-dropdown-item>
            <b-dropdown-item v-if="isAdmin || isTargetMaster || isLocalAdministrator || isGod" to="/v2/target/ranges">{{
                $t('ranges.ranges')
            }}</b-dropdown-item>
            <b-dropdown-item
                v-if="isAdmin || isTargetMaster || isLocalAdministrator || isGod"
                to="/v2/target/units-of-measurement"
                >{{ $t('unitsOfMeasurement.unitsOfMeasurement') }}</b-dropdown-item
            >
        </template>
    </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'

export default {
    name: 'DefaultTargetDropdown',
    props: ['hasKpi', 'hasTarget', 'isAdmin', 'isTargetMaster', 'isLocalAdministrator', 'isGod'],
    components: {
        AppHeaderDropdown,
    },
}
</script>

<style>
/*
    Ativando o título [Target] da navbar quando algum item do dropdown está selecionado.
    ATENÇÃO: Este 'style' não pode ser 'scoped'.
  */
.nav-item.b-nav-dropdown.dropdown {
    color: inherit;
}
.nav-link.dropdown-toggle {
    color: inherit;
}
.nav-link.active .nav-item.b-nav-dropdown.dropdown .nav-link.dropdown-toggle .active {
    color: inherit;
}
/*
    FIM.
  */
</style>
